import { useRouter } from "next/router";

import { AuthCardProps } from "@/features/auth/components/AuthCard";
import { useCallbackUrl } from "@/features/auth/hooks/useCallbackUrl";
import { Button } from "@/features/common/components/Button";
import { userRoleSlug } from "@/features/user/consts/userRoleSlug";
import { userRoles } from "@/features/user/consts/userRoles";
import { UserRoleEnum } from "@/generated/graphql-hooks";
import { getPublicConfig } from "@/helpers/getPublicConfig";
import AgentIcon from "@/icons/role/agent.svg";
import BusinessIcon from "@/icons/role/business.svg";
import ModelIcon from "@/icons/role/model.svg";

const {
  features: { agent },
} = getPublicConfig();

const userRoleList = [
  {
    name: userRoles[UserRoleEnum.Business],
    value: userRoleSlug[UserRoleEnum.Business],
    icon: BusinessIcon,
  },
  {
    name: userRoles[UserRoleEnum.Model],
    value: userRoleSlug[UserRoleEnum.Model],
    icon: ModelIcon,
  },
  ...(!!agent.enabled
    ? [
        {
          name: userRoles[UserRoleEnum.Agent],
          value: userRoleSlug[UserRoleEnum.Agent],
          icon: AgentIcon,
        },
      ]
    : []),
];

export const RoleSelection = ({ authType = "signup" }: AuthCardProps) => {
  const { push } = useRouter();
  const callbackUrl = useCallbackUrl();

  return (
    <div className="space-y-4">
      {userRoleList.map(({ name, value, icon: Icon }, index) => (
        <Button
          key={index}
          className="hover:!border-primary hover:!bg-secondary hover:!text-primary !rounded-lg !border-gray-50 !bg-gray-50 py-10 !text-gray-500"
          onClick={() =>
            push(
              `/${authType}/${value}`,
              callbackUrl && { query: { callbackUrl } },
            )
          }
        >
          <div className="flex flex-col items-center justify-center space-y-4 text-3xl ">
            <Icon />
            <div className="text-gray-700">
              {authType === "signin" ? "登入" : "註冊"}
              <span className="text-primary">{name}帳戶</span>
            </div>
          </div>
        </Button>
      ))}
    </div>
  );
};
